// extracted by mini-css-extract-plugin
export default {"header":"App_header__NiW2c","headingFont":"App_headingFont__wOGKJ","logo":"App_logo__9xoKS","body":"App_body__psWpO"};